import React, { Component } from "react";

const Time = ({ width, height,fill, style, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      style={style}
    >
      <path
        d="M15 0C6.72886 0 0 6.72886 0 15C0 23.2712 6.72886 30 15 30C23.2712 30 30 23.2711 30 15C30 6.72886 23.2712 0 15 0ZM15 26.7213C8.5367 26.7213 3.27869 21.4633 3.27869 15C3.27869 8.53702 8.5367 3.27869 15 3.27869C21.4633 3.27869 26.7213 8.53702 26.7213 15C26.7213 21.4633 21.4633 26.7213 15 26.7213Z"
        fill={fill}
      />
      <path
        d="M16.2982 15.0191V8.73224C16.2982 8.03027 15.7293 7.46143 15.0276 7.46143C14.3257 7.46143 13.7568 8.03027 13.7568 8.73224V15.425C13.7568 15.445 13.7618 15.4638 13.7627 15.4838C13.746 15.8293 13.8651 16.1802 14.129 16.4441L18.8618 21.1766C19.3582 21.673 20.1627 21.673 20.6588 21.1766C21.1549 20.6802 21.1552 19.8756 20.6588 19.3795L16.2982 15.0191Z"
        fill={fill}
      />
    </svg>
  );
};

Time.defaultProps = {
    fill: 'black',
    width: 30,
    height: 30,
  };

export default Time;
